import React, { useState } from "react";
import "./Login.css";
import AgentPasswordResetOverlay from "../components/resetPassword/ResetPassword";

const signInUrl = process.env.REACT_APP_Back_end_api_root + "/marketingAgentApp/signIn";

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [resetPasswordOverlay, setResetPasswordOverlay] = useState(false);
  const [markentAgentDataCopy, setMarkentAgentDataCopy] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    let payload = {
      agentEmail: formData.email,
      agentPassword: formData.password,
    };
    try {
      const response = await fetch(signInUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (response.status === 401) {
        setError(data.message || "Invalid credentials");
        //throw new Error(response.message);
        return;
      }
      if (response.status === 404) {
        setError(data.message || "Account not found");
        //throw new Error(response.message);
        return;
      }

      if (!response.ok) {
        throw new Error(data.message || "Failed to sign in");
      }

      if (data.marketingAgent.resigned || data.marketingAgent.isfired) {
        alert("Your account is no longer active. Please contact support for more information.");
        localStorage.removeItem("agentData");
        window.location.href = "/sign-in";
        return;
      }

      // Mock agent data
      const mockAgentData = {
        id: "AG-" + Math.random().toString(36).substr(2, 9).toUpperCase(),
        name: "John Doe",
        email: formData.email,
        phone: "+234 801 234 5678",
        joinDate: "2024-01-15",
        totalClients: 24,
        activeClients: 18,
        conversions: 12,
        totalCommission: 450000,
        pendingPayout: 125000,
        referralCode: "SL-" + Math.random().toString(36).substr(2, 6).toUpperCase(),
        ...data.marketingAgent,
      };
      setMarkentAgentDataCopy(mockAgentData);
      console.log("Mock Agent Data:", data.marketingAgent.isPasswordTemporary);

      if (data.marketingAgent.isPasswordTemporary) {
        console.log("====================================");
        console.log("Temporary password detected, prompting for reset.");
        console.log("====================================");
        setResetPasswordOverlay(true);
        return;
      }

      localStorage.setItem("loginTime", Date.now().toString());

      onLogin(mockAgentData);

      // Assuming the API returns agent data on successful login
      //  onLogin(data.marketingAgent);
    } catch (error) {
      console.log("Login error:", error);

      setError("An error occurred during sign in");
    } finally {
      setLoading(false);
    }

    // Simulate API call
    /*  setTimeout(() => {
      if (formData.email && formData.password) {
     
      } else {
        setError("Please enter valid credentials");
      }
      setLoading(false);
    }, 1500); */
  };

  return (
    <>
      <div className='sl-agent-login-container'>
        <div className='sl-agent-login-card'>
          <div className='sl-agent-login-header'>
            <div className='sl-agent-login-logo'>
              <div className='sl-agent-logo-icon'>
                {" "}
                <img
                  style={{
                    width: "100%",
                  }}
                  src='https://res.cloudinary.com/ebuka1122/image/upload/v1752244790/StorelenseLogos/StorelenseLogo_tqya01.webp'
                  alt='StoreLense Logo'
                />
              </div>
              <h1>
                <b
                  style={{
                    color: "#0F49B5",
                  }}
                >
                  Store
                </b>
                <b
                  style={{
                    color: "#3BB4C4",
                  }}
                >
                  Lense
                </b>
              </h1>
            </div>
            <h2>Agent Portal</h2>
            <p>Sign in to access your dashboard</p>
          </div>

          <form onSubmit={handleSubmit} className='sl-agent-login-form'>
            {error && <div className='sl-agent-error-message'>{error}</div>}

            <div className='sl-agent-form-group'>
              <label htmlFor='email'>Email Address</label>
              <input type='email' id='email' name='email' value={formData.email} onChange={handleChange} placeholder='agent@storelense.com' required />
            </div>

            <div className='sl-agent-form-group'>
              <label htmlFor='password'>Password</label>
              <input
                type='password'
                id='password'
                name='password'
                value={formData.password}
                onChange={handleChange}
                placeholder='Enter your password'
                required
              />
            </div>

            <button type='submit' className='sl-agent-login-btn' disabled={loading}>
              {loading ? (
                <span className='sl-agent-btn-loading'>
                  <span className='sl-agent-spinner'></span>
                  Signing in...
                </span>
              ) : (
                "Sign In"
              )}
            </button>

            <div className='sl-agent-login-footer'>
              <a href='#forgot' className='sl-agent-forgot-link'>
                Forgot Password?
              </a>
            </div>
          </form>
        </div>

        <div className='sl-agent-login-bg-shapes'>
          <div className='sl-agent-shape sl-agent-shape-1'></div>
          <div className='sl-agent-shape sl-agent-shape-2'></div>
          <div className='sl-agent-shape sl-agent-shape-3'></div>
        </div>
      </div>
      {resetPasswordOverlay && (
        <AgentPasswordResetOverlay
          isOpen={resetPasswordOverlay}
          onClose={() => setResetPasswordOverlay(false)}
          onPasswordReset={() => onLogin(markentAgentDataCopy)}
          markentAgentDataCopy={markentAgentDataCopy}
        />
      )}
    </>
  );
};

export default Login;
